export const START_IMPERSONATION = "START_IMPERSONATION";
export const END_IMPERSONATION_TOOLTIP = "END_IMPERSONATION_TOOLTIP";
